








































































import { Component, Vue, Prop } from 'vue-property-decorator';
// import vue from 'vue';

@Component
export default class SustainabilityQuestions extends Vue {
}


